import { Wallet } from "lucide-react";

/**
 * Modal allowing the courier to top up their wallet via PayTech.
 */
export const WalletRechargeModal = ({
  open,
  walletBalance,
  rechargeAmount,
  onChangeAmount,
  onClose,
  onSubmit,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-md z-[200] flex items-end md:items-center justify-center p-4"
      data-testid="recharge-modal"
    >
      <div className="bg-[#0F172A] border border-white/10 rounded-[2rem] p-6 md:p-8 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full bg-white/5 text-slate-400 hover:text-white"
          data-testid="recharge-close-btn"
        >
          ✕
        </button>
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#B8962E] flex items-center justify-center mb-4">
          <Wallet size={24} className="text-[#0F172A]" />
        </div>
        <h3 className="text-xl font-black italic uppercase tracking-tight text-white mb-1">
          Recharger mon Wallet
        </h3>
        <p className="text-xs text-slate-400 mb-6">
          Solde actuel :{" "}
          <span className="text-[#D4AF37] font-black">
            {walletBalance.toLocaleString()} FCFA
          </span>
        </p>
        <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-2">
          Montant à créditer
        </p>
        <div className="grid grid-cols-3 gap-2 mb-4">
          {[1000, 2000, 5000, 10000, 25000, 50000].map((v) => (
            <button
              key={v}
              onClick={() => onChangeAmount(v)}
              className={`py-2 rounded-xl text-xs font-black uppercase tracking-widest border transition-all ${
                rechargeAmount === v
                  ? "bg-[#D4AF37] text-[#0F172A] border-transparent"
                  : "bg-white/5 text-slate-300 border-white/10 hover:border-[#D4AF37]/50"
              }`}
              data-testid={`recharge-amount-${v}`}
            >
              {v >= 1000 ? `${v / 1000}K` : v} F
            </button>
          ))}
        </div>
        <input
          type="number"
          min="500"
          step="100"
          value={rechargeAmount}
          onChange={(e) => onChangeAmount(parseInt(e.target.value, 10) || 0)}
          className="w-full bg-[#1E293B] border border-white/10 rounded-xl px-4 py-3 text-white font-bold text-sm mb-4 focus:outline-none focus:border-[#D4AF37]"
          data-testid="recharge-custom-input"
        />
        <button
          onClick={() => onSubmit(rechargeAmount)}
          disabled={!rechargeAmount || rechargeAmount < 500}
          className="w-full bg-gradient-to-r from-[#D4AF37] to-[#B8962E] hover:opacity-90 disabled:opacity-40 text-[#0F172A] py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-lg shadow-[#D4AF37]/20"
          data-testid="recharge-submit-btn"
        >
          Payer via PayTech (Wave / Orange Money)
        </button>
        <p className="text-[9px] text-slate-500 text-center mt-3">
          Vous serez redirigé vers PayTech pour finaliser le paiement.
        </p>
      </div>
    </div>
  );
};
